import React from "react";
import "semantic-ui-css/semantic.min.css";
import { Route, Switch } from "react-router";
import LayoutPage from "./Layout/LayoutPage";
import RoutePage from "./Layout/RoutePage";
import GameCategoryPage from "./Category/GameCategoryPage";
import categories from "./config/category";

const title = "Flash Games for Chinese Teaching (Yumin Hsu)";

const renderRoutes = () => {
    return (
        <Switch>
            <Route path={"/:category/:gameid"} component={RoutePage} />
            <Route path={"/:category"} component={GameCategoryPage} />
            <Route
                path="/"
                render={() => (
                    <LayoutPage categories={categories} title={title} />
                )}
            />
        </Switch>
    );
};

const App = () => {
    return renderRoutes();
};

export default App;
